import Joi from "joi";

export default Joi.object({
	client_id: Joi.string().required(),
	client_secret: Joi.string().required(),
	username: Joi.string().required(),
	password: Joi.string().required()
});
